import React, { useState, useEffect } from "react";
import { makeStyles, Button, Dialog, IconButton, } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import imageCompression from 'browser-image-compression';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';
import config from '../config.json';
import ImageGallery from 'react-image-gallery';
import DownloadIcon from "@material-ui/icons/GetApp";

const useStyles = makeStyles({
    imageContainer: {
        backgroundPosition: "center",
        backgroundSize: "cover",
        paddingTop: "60%",
        position: "relative",
        borderRadius: 8,
        border: "1px solid #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    removeButton: {
        position: "absolute",
        top: 3,
        right: 2,
        width: 21,
        height: 21,
        backgroundColor: "#fff",
        borderRadius: 200,
        border: "1px solid #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer"
        },
    },
    closeButton: {
        position: "absolute",
        top: 10,
        right: 10,
        borderRadius: 100,
        backgroundColor: "#00000060",
        display: "grid",
        justifyContent: "center",
        padding: 4,
        '&:hover': {
            cursor: "pointer"
        }
    },
    paperScrollPaper: {
        overflow: "visible",
        backgroundColor: "#0000",
        boxShadow: "none"
    }
});

export default function CustomImageInput({ value, onChange, enableRemoveImageHandler = false, type = "", id = "", style = {} }) {
    const classes = useStyles();
    const [image, setImage] = useState("");

    const [dialogVisible, setDialogVisible] = useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const updateImages = img => {
        setImage(img);
    };

    const addImage = async event => {
        if (event.target.files && event.target.files[0]) {
            const imageFile = event.target.files[0];
            const temp = URL.createObjectURL(imageFile);
            updateImages(temp);

            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            };

            try {
                const compressedFile = await imageCompression(imageFile, options);
                updateImages(URL.createObjectURL(compressedFile));
                onChange(compressedFile);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const removeImage = () => {
        updateImages("");
        onChange("")

        if (enableRemoveImageHandler && type && id) savePermitDocuments()
    };

    const savePermitDocuments = async () => {
        fetch(`${config.HOST_NAME}/crm/documents/remove`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id, type })
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .catch(e => {
                notify("Something went wrong", "warning");
            });
    };

    useEffect(() => {
        if (value != null && value !== "") {
            try {
                setImage(value);
            } catch (e) { }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const renderCustomControls = () => {
        return (
            <a style={{ position: 'absolute', top: 60, right: 12, color: 'white', textDecoration: 'none', background: 'rgba(0,0,0,0.5)', padding: '10px 10px', borderRadius: '50px', zIndex: 1 }}
                href={image}
                download
            >
                <DownloadIcon fontSize="small" />
            </a>
        );
    };

    return (
        <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, 150px)", gap: 15, ...style }}>
                {!image ? (
                    <Button className={classes.imageContainer} style={{ padding: 0, position: "relative", minHeight: 91 }}>
                        <AddIcon style={{ fontSize: 40, color: "#444" }} />
                        <input
                            type="file"
                            accept="image/png, image/jpeg"
                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0 }}
                            onChange={addImage}
                        />
                    </Button>
                ) : (
                    <div className={classes.imageContainer} style={{ backgroundImage: `url(${image})` }}
                        onClick={() => openDialog()}
                    >
                        <div className={classes.removeButton}
                            onClick={(event) => {
                                event.stopPropagation();
                                removeImage();
                            }}
                        >
                            <CloseIcon style={{ fontSize: 16 }} />
                        </div>
                    </div>
                )}
            </div>

            <Dialog open={dialogVisible} onClose={closeDialog} scroll="body" classes={{ paperScrollBody: classes.paperScrollPaper }}>
                <ImageGallery
                    items={[{ original: image, thumbnail: image }]}
                    showPlayButton={false}
                    stopPropagation={true}
                    renderCustomControls={() => renderCustomControls()}
                />

                <div className={classes.closeButton} onClick={closeDialog}>
                    <CloseIcon style={{ fontSize: 30, color: "#fff" }} />
                </div>
            </Dialog>
        </>
    );
}
